import { AwsSqsRegistration } from "@p0security/integrations-aws-sqs-shared";
import type { AwsSqsComponents } from "@p0security/integrations-aws-sqs-shared";
import { Install } from "@p0security/integrations-installer";
import type { InstallProps } from "@p0security/integrations-installer";

import { awsSqsInstaller } from "./install";

export const AwsSqs = (
  props: Pick<
    InstallProps<typeof AwsSqsComponents>,
    "cardOverride" | "onInstall" | "siblings"
  >
) => (
  <Install<typeof AwsSqsComponents>
    installer={awsSqsInstaller}
    integration="aws-sqs"
    registration={AwsSqsRegistration}
    {...props}
  />
);
